import { render, staticRenderFns } from "./CoordinatedAppointmentView.vue?vue&type=template&id=cc85a5ae&scoped=true"
import script from "./CoordinatedAppointmentView.vue?vue&type=script&lang=js"
export * from "./CoordinatedAppointmentView.vue?vue&type=script&lang=js"
import style0 from "./CoordinatedAppointmentView.vue?vue&type=style&index=0&id=cc85a5ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc85a5ae",
  null
  
)

export default component.exports